var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame631(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 169,
    viewBox: "0 0 160 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.958,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9063 7.65666C80.5653 7.36463 81.6591 7.98963 82.1875 9.53166C82.396 25.0525 82.396 40.5732 82.1875 56.0942C82.0422 56.5413 81.7816 56.9057 81.4063 57.1879C68.0841 57.5957 60.1153 64.3145 57.5 77.3442C57.0006 88.067 61.5319 95.8276 71.0938 100.625C81.2122 104.203 89.9103 102.067 97.1875 94.2192C100.723 89.3929 102.546 83.9763 102.656 77.9692C102.93 77.7345 103.243 77.5782 103.594 77.5004C106.719 77.292 109.844 77.292 112.969 77.5004C113.364 77.597 113.729 77.7532 114.063 77.9692C114.389 94.3535 107.045 105.76 92.0313 112.188C75.9191 117.059 62.5338 113.048 51.875 100.157C45.1063 90.0651 43.6478 79.232 47.5 67.6567C52.9669 54.682 62.7066 47.2342 76.7188 45.3129C76.875 45.1567 77.0313 45.0004 77.1875 44.8442C77.2916 33.0732 77.396 21.3025 77.5 9.53166C77.6872 8.67098 78.156 8.04598 78.9063 7.65666Z",
    fill: "#ABABAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.594 18.9059C124.82 18.7642 125.81 19.1808 126.562 20.1559C126.573 24.6642 126.781 29.1434 127.187 33.5934C131.487 33.8509 135.81 34.0071 140.156 34.0621C141.591 34.9296 141.955 36.1274 141.25 37.6559C134.418 44.5918 127.491 51.4149 120.469 58.1246C115.336 58.1337 110.232 58.3421 105.156 58.7496C97.2395 66.6662 89.3227 74.5831 81.4061 82.4996C78.0961 83.6681 76.8983 82.5743 77.8123 79.2184C85.8333 71.1974 93.8539 63.1768 101.875 55.1559C101.884 50.0231 102.092 44.919 102.5 39.8434C109.498 32.7927 116.53 25.8136 123.594 18.9059Z",
    fill: "#ABABAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.976,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4701 23.2817C66.2313 23.2245 66.9085 23.4329 67.5013 23.9067C67.7097 30.2609 67.7097 36.6151 67.5013 42.9692C50.4479 50.1923 41.5416 63.1089 40.7826 81.7192C40.4301 81.9573 40.0654 82.1658 39.6888 82.3442C29.4507 82.0848 19.1903 81.9286 8.90755 81.8754C7.19302 80.2876 7.29721 78.8292 9.22005 77.5004C13.5951 77.3964 17.9701 77.292 22.3451 77.1879C24.0968 57.4358 33.0551 41.9151 49.2201 30.6254C54.3491 27.4776 59.7657 25.0297 65.4701 23.2817Z",
    fill: "#D11116"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.957,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6556 61.4061C78.9099 61.3542 80.1599 61.4064 81.4056 61.5624C81.5618 61.7186 81.7181 61.8749 81.8743 62.0311C82.4993 64.0102 82.4993 65.9896 81.8743 67.9686C79.1659 70.6771 76.4577 73.3852 73.7493 76.0936C71.2293 79.8717 71.5937 83.3614 74.8431 86.5624C78.1943 89.2455 81.5277 89.2455 84.8431 86.5624C87.864 83.5414 90.8846 80.5208 93.9056 77.4999C95.2981 77.2289 96.6521 77.333 97.9681 77.8124C98.8437 85.6458 95.9268 91.6874 89.2181 95.9374C80.7146 99.9858 73.0584 98.788 66.2493 92.3436C62.3187 87.7355 60.8606 82.423 61.8743 76.4061C63.9734 68.0452 69.234 63.0452 77.6556 61.4061Z",
    fill: "#ABABAB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.973,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.845 77.3438C130.053 77.2916 140.262 77.3438 150.47 77.5C151.946 78.261 152.415 79.4591 151.876 81.0938C151.616 81.3541 151.355 81.6147 151.095 81.875C146.482 81.8854 141.899 82.0935 137.345 82.5C135.204 105.555 123.85 122.222 103.282 132.5C100.726 133.561 98.1215 134.498 95.4697 135.313C94.0337 135.748 92.5756 135.852 91.0947 135.625C90.7325 129.554 90.6803 123.46 90.9384 117.344C93.4359 116.017 95.9878 114.714 98.5947 113.438C111.73 105.352 118.449 93.5291 118.751 77.9688C119.158 77.786 119.522 77.5779 119.845 77.3438Z",
    fill: "#D11116"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.968,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1563 90.7813C30.8864 90.7291 36.6156 90.7813 42.3438 90.9375C49.5016 108.665 62.6788 117.988 81.875 118.906C82.3913 129.192 82.4953 139.505 82.1875 149.844C81.5688 151.533 80.3706 152.106 78.5938 151.563C78.1097 151.183 77.7453 150.714 77.5 150.156C77.445 145.914 77.2888 141.695 77.0313 137.5C54.4959 135.263 38.1938 124.065 28.125 103.906C26.1441 99.9463 24.9983 95.7797 24.6875 91.4063C24.9116 91.2363 25.0679 91.0279 25.1563 90.7813Z",
    fill: "#D11116"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 164.5,
    rx: 69,
    ry: 4.5,
    fill: "url(#paint0_radial_236_34418)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_236_34418",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80 164.5) scale(69 4.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame631);
export default __webpack_public_path__ + "static/media/Frame 63 (1).f848f24b7fa68919c6db13c7b6decf66.svg";
export { ForwardRef as ReactComponent };